<template>
  <section id="services" class="padding-x mb-20">
    <div class="flex w-full flex-col">
      <h1
        id="what-i-do"
        v-html="whatIDo"
        class="heading-1 font-extrabold uppercase"
      ></h1>

      <div
        id="services-text"
        class="grid-gap mt-[5%] grid grid-cols-12 justify-end text-[#DC91A6] opacity-0 lg:grid"
      >
        <p
          class="col-start-0 heading-6 col-span-4 text-nowrap text-center text-[#DC91A6] md:col-start-4"
        >
          <img src="/gato.svg" alt="Gato" />
          ~Miauu
        </p>
        <p
          class="heading-4 font-fancy col-span-8 w-full text-balance sm:font-semibold md:col-span-5"
        >
          Tudo isso junto no fim do ano gera mais crescimento de Marca & Lucro.
        </p>
      </div>
    </div>

    <div class="relative mt-12 w-full lg:mt-[10%]">
      <div class="mt-12 flex flex-col justify-between gap-y-16">
        <ServicesCard
          v-for="(card, index) in servicesCardProps"
          :key="index"
          :number="index + 1"
          :title="card.title"
          :body="card.body"
          :headings="card.headings"
          :shape="card.shape"
          class="sticky border-t border-[#DC91A6] bg-[#2a2a2a]"
          :class="getStyle(index)"
        />
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
  import { animateSplitText } from '@/animations';
  import { textSplitterIntoChar } from '@/functions';
  import { onBeforeMount, onMounted, ref } from 'vue';
  import { ServicesCard } from '..';

  const whatIDo = ref('My services /');

  const servicesCardProps = [
    {
      title: 'Gestão de Redes Sociais',
      body: 'Nós ajudamos marcas a crescer nas redes sociais com estratégias personalizadas que aumentam visibilidade, engajamento e autoridade no mercado.',
      headings: [
        'Planejamento Semanal',
        'Estratégia de Crescimento',
        'Aumento de Engajamento',
        'Aumento de Seguidores',
        'Calendário de Publicações',
        'Análise de Concorrentes',
        'Relatórios Personalizados',
      ],
      shape: `<svg viewBox="0 0 200 200"  xmlns="http://www.w3.org/2000/svg">
  <path d="M100 0C103.395 53.7596 146.24 96.6052 200 100C146.24 103.395 103.395 146.24 100 200C96.6052 146.24 53.7596 103.395 0 100C53.7596 96.6052 96.6052 53.7596 100 0Z"/>
  </svg>
  `,
    },
    {
      title: 'Ações de Inbound Marketing',
      body: 'Nós criamos estratégias de marketing digital focadas em atrair, converter e fidelizar clientes, gerando valor e impulsionando vendas.',
      headings: [
        'Criação de Conteúdo',
        'Atração e Qualificação',
        'Conversão e Segmentação',
        'Nutrição e Relacionamento',
        'Impulsionamento de Vendas',
        'Fidelização de Clientes',
      ],
      shape: `<svg viewBox="0 0 200 200"  xmlns="http://www.w3.org/2000/svg">
  <path d="M100 0C103.395 53.7596 146.24 96.6052 200 100C146.24 103.395 103.395 146.24 100 200C96.6052 146.24 53.7596 103.395 0 100C53.7596 96.6052 96.6052 53.7596 100 0Z"/>
  </svg>
  `,
    },
    {
      title: 'Criação & Arte Design',
      body: 'Nós desenvolvemos identidades visuais e peças criativas que refletem o posicionamento das marcas, gerando valor e reconhecimento no mercado.',
      headings: [
        'Marcas & Logotipos',
        'Banners e Peças Digitais',
        'Anúncios Variados',
        'Capas e Identidade Visual',
        'Alinhamento Visual',
      ],
      shape: `<svg viewBox="0 0 200 200"  xmlns="http://www.w3.org/2000/svg">
  <path d="M100 0C103.395 53.7596 146.24 96.6052 200 100C146.24 103.395 103.395 146.24 100 200C96.6052 146.24 53.7596 103.395 0 100C53.7596 96.6052 96.6052 53.7596 100 0Z"/>
  </svg>
  `,
    },
  ];

  onBeforeMount(() => {
    whatIDo.value = textSplitterIntoChar('Serviços', true);
  });

  onMounted(() => {
    animateSplitText('#what-i-do .letters', '#services-text', 0.7, 0.01, 0);
  });

  const getStyle = (index: number) => {
    if (index === 0) {
      return 'top-[calc(20vh_+_0em)] mb-[17.25em]';
    }

    if (index === 1) {
      return 'top-[calc(20vh_+_5.75em)] mb-[11.5em]';
    }

    if (index === 2) {
      return 'top-[calc(20vh_+_11.5em)] mb-[5.75em]';
    }
  };
</script>
